// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shimmering text effect */
.shimmer-text {
  display: inline-block;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(0, 0, 0, 0.3) 100%);
  background-size: 200% auto;
  /* Makes the gradient larger than the text */
  color: transparent;
  /* Makes the text invisible */
  -webkit-background-clip: text;
  /* Clips the background to the text */
  background-clip: text;
  /* Standard property for background clipping */
  animation: shimmer 1.5s infinite;
  /* Adds animation */
}

/* Shimmer animation */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
    /* Starts gradient off-screen */
  }
  100% {
    background-position: 200% 0;
    /* Ends gradient off-screen */
  }
}
/* Default shimmering text effect */
.shimmer-text {
  display: inline-block;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(0, 0, 0, 0.3) 100%);
  background-size: 200% auto;
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  animation: shimmer 1.5s infinite;
}

/* Default shimmering text effect */
.shimmer-text {
  display: inline-block;
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.6) 50%, rgba(0, 0, 0, 0.3) 100%);
  background-size: 200% auto;
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  animation: shimmer 1.5s infinite;
}

/* Bright green shimmering effect for 'Speak Now' */
.shimmer-text-green {
  display: inline-block;
  background: linear-gradient(90deg, rgba(0, 255, 0, 0.5) 0%, lime 50%, rgba(0, 255, 0, 0.5) 100%);
  background-size: 200% auto;
  color: transparent;
  -webkit-background-clip: text;
  background-clip: text;
  animation: shimmer-green 1.5s infinite;
}

/* Default shimmer animation */
@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
/* Bright green shimmer animation */
@keyframes shimmer-green {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}`, "",{"version":3,"sources":["webpack://./../jobportal/src/components/PortalSelfAssessment/InteractWithAI/components/InterviewVideoChatPlatform/InterviewVideoAIPlatform/InterviewVideoAI.scss"],"names":[],"mappings":"AAAA,2BAAA;AACA;EACE,qBAAA;EACA,0GAAA;EAMA,0BAAA;EAA4B,4CAAA;EAC5B,kBAAA;EAAoB,6BAAA;EACpB,6BAAA;EAA+B,qCAAA;EAC/B,qBAAA;EAAuB,8CAAA;EACvB,gCAAA;EAAkC,mBAAA;AACpC;;AAEA,sBAAA;AACA;EACE;IACE,4BAAA;IAA8B,+BAAA;EAEhC;EAAA;IACE,2BAAA;IAA6B,6BAAA;EAG/B;AACF;AAAA,mCAAA;AACA;EACE,qBAAA;EACA,0GAAA;EAMA,0BAAA;EACA,kBAAA;EACA,6BAAA;EACA,qBAAA;EACA,gCAAA;AAHF;;AAMA,mCAAA;AACA;EACE,qBAAA;EACA,0GAAA;EAMA,0BAAA;EACA,kBAAA;EACA,6BAAA;EACA,qBAAA;EACA,gCAAA;AARF;;AAWA,mDAAA;AACA;EACE,qBAAA;EACA,gGAAA;EAMA,0BAAA;EACA,kBAAA;EACA,6BAAA;EACA,qBAAA;EACA,sCAAA;AAbF;;AAgBA,8BAAA;AACA;EACE;IACE,4BAAA;EAbF;EAeA;IACE,2BAAA;EAbF;AACF;AAgBA,mCAAA;AACA;EACE;IACE,4BAAA;EAdF;EAgBA;IACE,2BAAA;EAdF;AACF","sourcesContent":["/* Shimmering text effect */\n.shimmer-text {\n  display: inline-block;\n  background: linear-gradient(\n    90deg,\n    rgba(0, 0, 0, 0.3) 0%,\n    rgba(0, 0, 0, 0.6) 50%,\n    rgba(0, 0, 0, 0.3) 100%\n  );\n  background-size: 200% auto; /* Makes the gradient larger than the text */\n  color: transparent; /* Makes the text invisible */\n  -webkit-background-clip: text; /* Clips the background to the text */\n  background-clip: text; /* Standard property for background clipping */\n  animation: shimmer 1.5s infinite; /* Adds animation */\n}\n\n/* Shimmer animation */\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0; /* Starts gradient off-screen */\n  }\n  100% {\n    background-position: 200% 0; /* Ends gradient off-screen */\n  }\n}\n\n/* Default shimmering text effect */\n.shimmer-text {\n  display: inline-block;\n  background: linear-gradient(\n    90deg,\n    rgba(0, 0, 0, 0.3) 0%,\n    rgba(0, 0, 0, 0.6) 50%,\n    rgba(0, 0, 0, 0.3) 100%\n  );\n  background-size: 200% auto;\n  color: transparent;\n  -webkit-background-clip: text;\n  background-clip: text;\n  animation: shimmer 1.5s infinite;\n}\n\n/* Default shimmering text effect */\n.shimmer-text {\n  display: inline-block;\n  background: linear-gradient(\n    90deg,\n    rgba(0, 0, 0, 0.3) 0%,\n    rgba(0, 0, 0, 0.6) 50%,\n    rgba(0, 0, 0, 0.3) 100%\n  );\n  background-size: 200% auto;\n  color: transparent;\n  -webkit-background-clip: text;\n  background-clip: text;\n  animation: shimmer 1.5s infinite;\n}\n\n/* Bright green shimmering effect for 'Speak Now' */\n.shimmer-text-green {\n  display: inline-block;\n  background: linear-gradient(\n    90deg,\n    rgba(0, 255, 0, 0.5) 0%,  /* Bright green - medium opacity */\n    rgba(0, 255, 0, 1) 50%,   /* Bright green - full opacity */\n    rgba(0, 255, 0, 0.5) 100% /* Bright green - medium opacity */\n  );\n  background-size: 200% auto;\n  color: transparent;\n  -webkit-background-clip: text;\n  background-clip: text;\n  animation: shimmer-green 1.5s infinite;\n}\n\n/* Default shimmer animation */\n@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n/* Bright green shimmer animation */\n@keyframes shimmer-green {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
